<template>
  <vg-field
      :class="{disabled: disabled}"
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :placeholder="`请输入${label}`"
      :disable="disabled"
      :value="value"
      type="textarea"
      autosize
      rows="1"
      @input="input"
  />
</template>

<script>
import VgField from "@/components/Commons/VgField.vue";

export default {
  name: "DpApplicationTextField",
  components: {VgField},
  props: {
    label: String,
    value: null,
    disabled: Boolean,
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>
.disabled >>> textarea {
  color: #B4B4B4;
}
</style>